import React from "react";
const DEFAULT_LOCALE = "en-GB";
const LocaleContext = React.createContext(DEFAULT_LOCALE);
export const LocaleProvider = LocaleContext.Provider;
export const useLocale = () => React.useContext(LocaleContext);
//# sourceMappingURL=LocaleProvider.js.map